var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3705_113977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3705_113977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 18.8346C9.54427 18.8346 9.15191 18.6714 8.82552 18.3451C8.49913 18.0187 8.33594 17.6263 8.33594 17.168H11.6693C11.6693 17.6263 11.5061 18.0187 11.1797 18.3451C10.8533 18.6714 10.4609 18.8346 10.0026 18.8346ZM3.33594 16.3346V14.668H5.0026V8.83464C5.0026 7.68186 5.34983 6.65755 6.04427 5.76172C6.73872 4.86589 7.64149 4.27908 8.7526 4.0013V3.41797C8.7526 3.07075 8.87413 2.77561 9.11719 2.53255C9.36024 2.2895 9.65538 2.16797 10.0026 2.16797C10.3498 2.16797 10.645 2.2895 10.888 2.53255C11.1311 2.77561 11.2526 3.07075 11.2526 3.41797V4.0013C11.4054 4.04297 11.5547 4.08811 11.7005 4.13672C11.8464 4.18533 11.9887 4.24436 12.1276 4.3138L10.8151 5.60547C10.6762 5.57769 10.5443 5.55339 10.4193 5.53255C10.2943 5.51172 10.1554 5.5013 10.0026 5.5013C9.08594 5.5013 8.30122 5.82769 7.64844 6.48047C6.99566 7.13325 6.66927 7.91797 6.66927 8.83464V14.668H13.3359V12.918L15.0026 11.2513V14.668H16.6693V16.3346H3.33594ZM10.0026 11.3346V8.77214L14.6068 4.1888C14.7318 4.0638 14.8707 3.97352 15.0234 3.91797C15.1762 3.86241 15.329 3.83464 15.4818 3.83464C15.6484 3.83464 15.8082 3.86589 15.9609 3.92839C16.1137 3.99089 16.2526 4.08464 16.3776 4.20964L17.1484 4.98047C17.2596 5.10547 17.3464 5.24436 17.4089 5.39714C17.4714 5.54991 17.5026 5.70269 17.5026 5.85547C17.5026 6.00825 17.4748 6.1645 17.4193 6.32422C17.3637 6.48394 17.2734 6.6263 17.1484 6.7513L12.5651 11.3346H10.0026ZM11.2526 10.0846H12.0443L14.5651 7.54297L14.1901 7.14714L13.7943 6.77214L11.2526 9.29297V10.0846ZM14.1901 7.14714L13.7943 6.77214L14.5651 7.54297L14.1901 7.14714Z",
    fill: "#516CD3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.67cfb892055a79146fa69d08947280fa.svg";
export { ForwardRef as ReactComponent };